import {Grid, Row, Col} from 'react-bootstrap';
import React, {Component} from 'react';
import IdentityCardType, {VALID_TYPE_IDENTITY_VALUES} from './../../components/identity_card_type/IdentityCardType';
import './selectIdentityCardType.css';
import cardTypeImageNew from './../../resources/images/card-identity-type-new.png';
import cardTypeImageOld from './../../resources/images/card-identity-type-old.png';
import {setData} from "../../redux/actionCreators";
import { connect } from "react-redux";
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';
import TitleComponent from '../../components/title/TitleComponent';

class SelectIdentityCardType extends Component {
    constructor(props) {
        super(props);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    onChangeHandler(value){
        this.props.setData({IDENTITY_CARD_TYPE: value});
    }

    render() {
        let data = this.props.data ? this.props.data : this.props.stepData;
        data = data ? data : {};
        const cardTypeSelected = data.IDENTITY_CARD_TYPE;

        return (
          <div className={'select-identity-card-type'}>
              <Grid>
                  <div className="content">
                      <Row className={'question'}>
                          <Col xs={12} >
                              <TitleComponent subtitle>¿Qué cédula de identidad tienes?</TitleComponent>
                          </Col>
                      </Row>
                      <IdentityCardType
                          name={'identity-card-type'}
                          onChangeHandler={this.onChangeHandler}
                          cardTypeSelected={cardTypeSelected ? data.IDENTITY_CARD_TYPE : null}
                          cardTypeToCompare={VALID_TYPE_IDENTITY_VALUES.CHL2}
                          image={cardTypeImageOld}
                          text={'Cédula tradicional'}
                          checked={cardTypeSelected ? VALID_TYPE_IDENTITY_VALUES.CHL2===data.IDENTITY_CARD_TYPE : false}
                      />
                      <IdentityCardType
                          name={'identity-card-type'}
                          onChangeHandler={this.onChangeHandler}
                          cardTypeSelected={cardTypeSelected ? data.IDENTITY_CARD_TYPE : null}
                          cardTypeToCompare={VALID_TYPE_IDENTITY_VALUES.CHL3}
                          image={cardTypeImageNew}
                          text={'Cédula nueva (2024)'}
                          checked={cardTypeSelected ? VALID_TYPE_IDENTITY_VALUES.CHL3===data.IDENTITY_CARD_TYPE : false}
                      />
                      <FooterContainer>
                        <MainButton 
                            onClick={this.props.nextStep}
                            disabled={!cardTypeSelected}
                            text={this.props.stepInfo.buttonText? this.props.stepInfo.buttonText : 'Continuar'}
                        />
                      </FooterContainer>
                  </div>
              </Grid>
          </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        data: state.data,
        stepData: state.stepData,

    };
};

const mapDispatchToProps = dispatch => {
    return {
        setData: (data) => {
            dispatch(setData(data));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectIdentityCardType);
